import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3, a as injectJwPlayerStatic } from './jw-player-base-injector-container.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$2 } from './jw-player-base-overlay.js';
import { d as defineCustomElement$1 } from './loader.js';

const WuiJwPlayerBaseInjector = /*@__PURE__*/ proxyCustomElement(class WuiJwPlayerBaseInjector extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.playerVersion = '';
        this.playerLicenseKey = '';
        this.playerOptions = undefined;
        this.jwPlayerStatic = undefined;
        this.playerLoading = true;
        this.playerError = undefined;
    }
    componentWillLoad() {
        (async () => {
            try {
                const jwPlayerStatic = await injectJwPlayerStatic(this.playerVersion, this.playerLicenseKey);
                this.jwPlayerStatic = jwPlayerStatic;
                this.playerError = undefined;
            }
            catch (err) {
                this.playerError = err instanceof Error ? err : new Error(String(err));
            }
        })();
    }
    render() {
        return (h(Host, { key: '9869e99e6f726dd735684e060f8a762308bd9118', class: "jw-player-base-injector", style: { flex: '1' } }, this.jwPlayerStatic && (h("wui-jw-player-base-injector-container", { key: '9cf79a8e543faa976edf1fbdfeb1773310fd325d', jwPlayerStatic: this.jwPlayerStatic, playerOptions: this.playerOptions, onPlayerSetup: () => {
                this.playerLoading = false;
            } })), h("wui-jw-player-base-overlay", { key: '857fa7e44497a48c3ed4a9a44009c3d956ee0f3d', visible: !!(this.playerError || this.playerLoading), error: this.playerError, loading: this.playerLoading, loadingText: "Player is loading" })));
    }
}, [0, "wui-jw-player-base-injector", {
        "playerVersion": [1, "player-version"],
        "playerLicenseKey": [1, "player-license-key"],
        "playerOptions": [16],
        "jwPlayerStatic": [32],
        "playerLoading": [32],
        "playerError": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-jw-player-base-injector", "wui-icon", "wui-jw-player-base-injector-container", "wui-jw-player-base-overlay", "wui-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-jw-player-base-injector":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiJwPlayerBaseInjector);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-jw-player-base-injector-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-jw-player-base-overlay":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiJwPlayerBaseInjector as W, defineCustomElement as d };

//# sourceMappingURL=jw-player-base-injector.js.map